// extracted by mini-css-extract-plugin
export default {"modal-body":"styles_modal-body__CJnbB","chat":"styles_chat__+DYjp","select-container":"styles_select-container__Ynkoo","delete-btn":"styles_delete-btn__0-7uA"};